export default "__VITE_ASSET__DdnyosRG__"